import { fromPairs, is, pipe, pathOr, clone, prop, map, includes, ifElse, identity } from 'ramda';

import { DEFAULT_SERIE_NAME, DEFAULT_LABEL_NAME } from './radialChart.constants';
import { mapIndexed } from '../../../utils/mapIndexed';

const roundIfNumber = ifElse(is(Number), Math.round, identity);

const parser = (rawData) => {
  const chartData = clone(rawData);
  chartData.serie = DEFAULT_SERIE_NAME;
  chartData.label = DEFAULT_LABEL_NAME;

  const seriesIndexes = pipe(
    prop('series'),
    map(String),
    mapIndexed((serie, index) => [serie, index]),
    fromPairs
  )(rawData);

  const getValues = (serie, data) =>
    data.reduce((list, item, index) => {
      const serieValue = seriesIndexes[serie];
      const itemValue = seriesIndexes[item];

      if (itemValue >= serieValue) list.push(index + 1);

      return list;
    }, []);

  const { labels = {} } = chartData;

  chartData.data = rawData.series.map((serie) => ({
    [DEFAULT_SERIE_NAME]: getValues(serie, rawData.data),
    [DEFAULT_LABEL_NAME]: labels[serie] || serie,
  }));

  return chartData;
};

export const schemaRadialParser = (rawData) => {
  const chartData = clone(rawData);

  const data = rawData.series.filter(pipe(String, includes('pI'))).map((id) => pathOr('', ['data', 0, id], rawData));
  chartData.data = data.map(roundIfNumber);
  chartData.rawData = data;
  chartData.series = [1, 2, 3, 4];

  return chartData;
};

export default parser;
